import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

import createPaginationControl from "../../Common/createPaginationControl";
import NavigationBarContainer from "../NavigationBarContainer";
import PiggdekkontrollerExcel from "./PiggdekkontrollExcel";
import PiggdekkontrollerFilterContainer from "./PiggdekkontrollFilterContainer";
import PiggdekkontrollList from "./PiggdekkontrollList";

import { getPiggdekkontrollerList } from "../../../selectors/piggdekkontrollerSelector";

import { getPiggdekkontroller as getPiggdekkontrollerAction } from "../../../actions/piggdekkontrollerActions";

import * as title from "../../../constants/titles";

const PaginationControl = createPaginationControl(
  "piggdekkontroller",
  {
    apiCallAction: getPiggdekkontrollerAction,
    queriesForApiReducerName: "forms.piggdekkontrollFilterForm",
  },
  getPiggdekkontrollerList,
);

function PiggdekkontrollerContainer() {
  const piggdekkontroller = useSelector((state) => state.piggdekkontroller);
  const piggdekkontrollerSubmittedForm = useSelector(
    (state) => state.submittedForms.piggdekkontrollerSubmittedForm,
  );

  useEffect(() => {
    document.title = title.rapporter.piggdekkontroll;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container fluid>
      <Row>
        <Col>
          <NavigationBarContainer page="piggdekkontroll" />
          <div className="rapportSearch">
            <PiggdekkontrollerFilterContainer />
          </div>
          <div
            className="rapport-buttons-container"
            style={{ marginBottom: 15 }}
          >
            <PiggdekkontrollerExcel
              piggdekkontroller={piggdekkontroller}
              piggdekkontrollerSubmittedForm={piggdekkontrollerSubmittedForm}
            />
          </div>
          <div className="rapport-table">
            <div className="table-wrapper-horizontal-scroll">
              <PiggdekkontrollList
                piggdekkontroller={piggdekkontroller.items}
              />
            </div>
            <PaginationControl storeKey="piggdekkontroller" />
          </div>
        </Col>
        <div style={{ height: 28 }} />
      </Row>
    </Container>
  );
}

export default PiggdekkontrollerContainer;
